import {announce} from '@github-ui/aria-live'
import {Banner} from '@primer/react'
import {useEffect, type RefObject} from 'react'

function focusAfterRender(ref: RefObject<HTMLElement | null>): void {
  setTimeout(() => ref.current?.focus({preventScroll: true}), 0)
}

function focusBannerOnMount(node: HTMLElement | null): void {
  node?.focus({preventScroll: true})
}

export function EnvironmentTaskLaunchFailureBanner({
  error,
  onAction,
  actionLabel = 'Retry starting agent',
  actionFocusRef,
}: {
  error: string
  onAction: () => void
  actionLabel?: string
  actionFocusRef: RefObject<HTMLElement | null>
}) {
  useEffect(() => {
    announce(`Agent startup did not finish. ${error}`, {assertive: true})
  }, [error])

  return (
    <Banner
      ref={focusBannerOnMount}
      variant="critical"
      title="Agent startup did not finish"
      description={error}
      primaryAction={
        <Banner.PrimaryAction
          onClick={() => {
            onAction()
            focusAfterRender(actionFocusRef)
          }}
        >
          {actionLabel}
        </Banner.PrimaryAction>
      }
    />
  )
}
